import configAxios from "../configuration/configAxios";
import {errorHandlerServices} from "../configuration/errorHandle";
import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {ProcessInterface, ProcessPermissionInterface} from "../interface/ProcessInterface";
import {DocumentProcessInterface} from "../interface/DocumentProcessInterface";
import {enqueueSnackbar} from "notistack";

export const createProcess = async (data: ProcessInterface) => {
    return await configAxios.post(`/ms-menus/process/createProcess`, data).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return response.data.object
        }
    }).catch(error => {
        errorHandlerServices(error, true)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/process/createProcess`);
    })
}

export const useCreateProcess = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: ProcessInterface) => createProcess(data),
    });
}

export const permissionProcess = async (data: ProcessPermissionInterface) => {
    return await configAxios.post(`/ms-menus/process/permissionProcessList`, data).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return response.data.object
        }
    }).catch(error => {
        errorHandlerServices(error, true)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/process/permissionProcess`);
    })
}

export const usePermissionProcess = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: ProcessPermissionInterface) => permissionProcess(data),
    });
}

export const saveDocumentProcess = async (data: DocumentProcessInterface) => {
    return configAxios.post(`/ms-archivos/documentProcess/create-file`, data).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return configAxios.post(`/ms-menus/process/createDocumentProcess`, {...data, idDocumentRepository: response.data.object.fileId}).then((responseWS) => {
                enqueueSnackbar(`Documento: ${data.name} guardado exitosamente`, { variant: 'success' });
                return responseWS.data.object
            }).catch(error => {
                errorHandlerServices(error, true)
                throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/process/saveDocumentProcess`);
            })
        }
    }).catch(error => {
        errorHandlerServices(error, true)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/process/saveDocumentProcess`);
    })
}

export const useSaveDocumentProcess = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: DocumentProcessInterface) => saveDocumentProcess(data),
    });
}

export interface FindInterface {
    filter?: string,
    dateInit?: Date,
    dateEnd?: Date,
    department?: number,
    page?: number,
    size?: number,
}

export const findAllProcess = async (data: FindInterface) => {
    return await configAxios.get(`/ms-menus/process/findAllProcess`, {
        params: {
            department: data.department,
            filter: data.filter,
            dateInit: data.dateInit,
            dateEnd: data.dateEnd,
            page: data.page,
            size: data.size
        }
    }).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return response.data.object
        }
    }).catch(error => {
        errorHandlerServices(error, true, true)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/process/findAllProcess`);
    })
}

export const useFindAllProcess = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: FindInterface) => findAllProcess(data),
    });
}
